import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22dc2c1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "content" }

import {
  computed,
  defineComponent,
  PropType,
  reactive,
  ref,
  onUnmounted,
  toRefs,
  watch,
  onMounted,
} from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import NAVLEFT from '../navLeft/navLeft.vue'
import { dateFormat, gaEvent } from '@/utils/format'


export default /*#__PURE__*/_defineComponent({
  __name: 'navTop',
  setup(__props) {

const store = useStore()
let router = useRouter()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NAVLEFT, { class: "sidebar theme-bg" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})